import { SearchContext, useSearchReducer } from 'hooks/useSearch'
import * as React from 'react'

export const SearchProvider: React.FunctionComponent = ({ children }) => {
  const [search, dispatch] = useSearchReducer()

  return (
    <SearchContext.Provider value={{ state: search, dispatch }}>
      {children}
    </SearchContext.Provider>
  )
}
